export default __webpack_public_path__ + "static/media/Bus Stop.01f0c2f2.png";